export default __webpack_public_path__ + "static/Portrait-Regular2-Web-7e622c7924b60d8eb86bf9015a4e3b2b.woff2";